import { JSX, useEffect, useState } from "react";
import { ColumnConfig, Waffles, wafflesKeyColumnName } from "@app/shared/waffles";
import { TextAlignment, WafflesThemes } from "@app/shared/waffles/exports";

interface NetworkFlyoutPlansTableProps {
  contractId: string;
  data: string[];
}

interface NetworkFlyoutPlansTableData {
  planName: string;
  [wafflesKeyColumnName]: string;
}

const columnConfig: ColumnConfig = {
  planName: {
    alignment: TextAlignment.Left,
    displayText: "Plan Name",
    noResize: true,
    noSort: true,
    testId: "plan-name",
  },
};

const NetworkFlyoutPlansTable = (props: NetworkFlyoutPlansTableProps): JSX.Element => {
  const [tableData, setTableData] = useState<NetworkFlyoutPlansTableData[]>([]);

  useEffect(() => {
    if (!!props.data) {
      /* eslint-disable sort-keys */
      const newTableData: NetworkFlyoutPlansTableData[] = props.data.map((plan, index) => {
        return {
          [wafflesKeyColumnName]: plan || index.toString(),
          planName: plan,
        }
      });
      /* eslint-enable sort-keys */

      setTableData(newTableData);
    }
  }, [props.data]);

  return (
    <div className="row">
      <div className="col-12">
        <Waffles<NetworkFlyoutPlansTableData>
          columns={columnConfig}
          data={tableData}
          fullWidth={true}
          testId={`network-benchmarking-dashboard--h-contract-flyout__plans-table-${props.contractId}`}
          theme={WafflesThemes.Simple}
        />
      </div>
    </div>
  )
}

export default NetworkFlyoutPlansTable;
